<template>
    <router-link class="return-button text-lg font-semibold" to="/">Return to Map</router-link>
</template>

<script>
    export default {
        name: "ReturnButton"
    }
</script>

<style lang="scss" scoped>
.return-button {    
    text-align: center;
    margin-top: 2rem;
    padding: 1rem;
    border-radius: 15px;
    background: theme('colors.blue.900');
    color: theme('colors.gray.100');
}
</style>